import type { NewsItem } from "@/types/movie";

export const news: NewsItem[] = [
  {
    id: "news-01",
    title: "《星际回响》上映首周票房破六亿，硬核科幻再度点燃银幕",
    excerpt:
      "由顾星河执导的科幻新作上映首周便斩获6.2亿元票房，观众对影片中对时间悖论的独特诠释展开热烈讨论。",
    date: "2026-10-12",
    tag: "票房",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20editorial%20image%20of%20a%20packed%20modern%20cinema%20lobby%20glowing%20with%20warm%20golden%20light%2C%20movie%20posters%20on%20the%20walls%2C%20atmospheric%20film%20industry%20mood&width=800&height=500&seq=yp-news-01&orientation=landscape",
    movieId: "star-echo",
  },
  {
    id: "news-02",
    title: "蓝鲸纪录片团队获年度自然影像大奖，导演分享拍摄幕后",
    excerpt:
      "《蓝鲸之梦》历时三年拍摄，制作团队首次公开深海拍摄的高难度细节与环保理念。",
    date: "2026-10-09",
    tag: "奖项",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20an%20underwater%20camera%20rig%20gently%20lit%20in%20deep%20blue%20ocean%2C%20bubbles%20and%20sunbeams%2C%20documentary%20production%20feel%2C%20cinematic&width=800&height=500&seq=yp-news-02&orientation=landscape",
    movieId: "blue-whale",
  },
  {
    id: "news-03",
    title: "悬疑片《第七个嫌疑人》宣布密钥延期，口碑持续走高",
    excerpt:
      "凭借环环相扣的本格推理与出色的群像表演，影片评分稳定在8.6分，片方宣布延长上映。",
    date: "2026-10-06",
    tag: "动态",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20dim%20interrogation%20room%20with%20a%20single%20overhead%20lamp%20and%20empty%20chairs%2C%20cold%20grey%20tones%20with%20amber%20glow%2C%20suspenseful%20cinematic%20mood&width=800&height=500&seq=yp-news-03&orientation=landscape",
    movieId: "seventh-suspect",
  },
  {
    id: "news-04",
    title: "《龙脊行动》发布制作特辑，实景搭建还原战场细节",
    excerpt:
      "为呈现真实的战场质感，剧组在海拔三千米的高原搭建实景，演员完成了大量高难度动作戏。",
    date: "2026-10-03",
    tag: "幕后",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20mountain%20film%20set%20at%20dusk%20with%20cranes%20and%20warm%20golden%20light%2C%20crew%20silhouettes%2C%20gritty%20cinematic%20production%20mood&width=800&height=500&seq=yp-news-04&orientation=landscape",
    movieId: "dragon-ridge",
  },
  {
    id: "news-05",
    title: "《母亲的针脚》点映收获好评，被赞“最朴素的催泪佳作”",
    excerpt:
      "影片在全国多城举行点映，观众纷纷表示被片中的亲情细节打动，直呼“看完想给妈妈打电话”。",
    date: "2026-09-29",
    tag: "口碑",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20image%20of%20sunlit%20window%20with%20a%20sewing%20machine%20and%20folded%20cloth%2C%20soft%20golden%20light%20and%20dust%20motes%2C%20nostalgic%20cinematic%20mood&width=800&height=500&seq=yp-news-05&orientation=landscape",
    movieId: "mother-stitch",
  },
  {
    id: "news-06",
    title: "国风动画《山海绘卷》定档暑期，首支预告惊艳亮相",
    excerpt:
      "以水墨美学重构山海异兽世界的动画电影公布上映日期，预告片上线一天播放量突破两千万。",
    date: "2026-09-25",
    tag: "定档",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20traditional%20ink%20wash%20painting%20landscape%20with%20floating%20mountains%20and%20a%20mythical%20silhouette%2C%20warm%20gold%20accents%2C%20elegant%20cinematic%20mood&width=800&height=500&seq=yp-news-06&orientation=landscape",
    movieId: "mountain-sea-scroll",
  },
  {
    id: "news-07",
    title: "《暗流迷局》带动刑侦题材回温，多线叙事成讨论热点",
    excerpt:
      "影片凭借缜密的多线叙事结构收获大量好评，观众自发绘制人物关系图进行剧情推演。",
    date: "2026-09-21",
    tag: "话题",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20foggy%20harbor%20at%20night%20with%20shipping%20containers%20and%20a%20lone%20lit%20window%2C%20cold%20grey%20green%20tones%2C%20mysterious%20cinematic%20mood&width=800&height=500&seq=yp-news-07&orientation=landscape",
    movieId: "dark-current",
  },
  {
    id: "news-08",
    title: "温情喜剧《笑闹人生》现场放映笑声不断，主创分享创作初衷",
    excerpt:
      "导演表示影片希望用笑声化解中年人的焦虑，让观众在轻松之余也能获得一点力量。",
    date: "2026-09-18",
    tag: "访谈",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20editorial%20image%20of%20a%20cheerful%20sunny%20town%20street%20with%20a%20red%20bicycle%20leaning%20against%20a%20wall%2C%20warm%20vivid%20colors%2C%20playful%20cinematic%20mood&width=800&height=500&seq=yp-news-08&orientation=landscape",
    movieId: "laugh-life",
  },
];